const doc = [({"en":({"models":({"team_survey":({"new":"New", "completed":"Completed", "expired":"Expired", "start":"Start", "end":"End"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;